import { useEffect, useState } from "react";
import { PrivateUser } from "../../CRUD/CampSites/types";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PrivateUserForm from "./PrivateUserForm";
import PrivateUserDetail from "./PrivateUserDetail";
import PrivateUserList from "./PrivateUserList";

const PrivateUsersManager = () => {
  const [privateUsers, setPrivateUsers] = useState<PrivateUser[]>([]);
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showForm, setShowForm] = useState(false);
  const [editingPrivateUser, setEditingPrivateUser] =
    useState<PrivateUser | null>(null);
  const [currentView, setCurrentView] = useState<"list" | "form" | "details">(
    "list"
  );
  const [selectedPrivateUser, setSelectedPrivateUser] =
    useState<PrivateUser | null>(null);

  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("accessToken");
 // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const navigate = useNavigate();

  const fetchPrivateUsers = async () => {
    // Fetch private users from the API
    try {
      const response = await axios.get<{ data: { data: PrivateUser[] } }>(
        `${apiUrl}/PrivateUser/getAllPrivateUsersWithBookings`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPrivateUsers(response.data.data.data || []);
    } catch (error) {
      console.error("Error fetching private users", error);
    }
  };

  useEffect(() => {
    fetchPrivateUsers();
  }, []);

  const handleUpdatePrivateUser = async (privateUser: PrivateUser) => {
    await fetchPrivateUsers();
    setShowForm(false);
    setCurrentView("list");
  };

  const handleCancelEdit = () => {
    setShowForm(false);
    setEditingPrivateUser(null);
    setCurrentView("list");
  };

  const handleViewPrivateUser = (privateUser: PrivateUser) => {
    setSelectedPrivateUser(privateUser);
    setCurrentView("details");
  };

  const handleDeletePrivateUser = async (Id: number) => {
    try {
      await axios.delete(`${apiUrl}/PrivateUser/deletePrivateUser/${Id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      await fetchPrivateUsers();
    } catch (error) {
      console.error("Error deleting private user", error);
    }
  };

  const handleSuccess = () => {
    fetchPrivateUsers();
    setShowForm(false);
    setEditingPrivateUser(null);
    setCurrentView("list");
  };

  const handleEditPrivateUser = (privateUser: PrivateUser) => {
    setEditingPrivateUser(privateUser);
    setShowForm(true);
    setCurrentView("form");
  };

  return (
    <div className="container mb-5 pb-5">
     
        {currentView === "list" && (
        <PrivateUserList
          privateUsers={privateUsers}
          onEdit={handleEditPrivateUser}
          onDelete={handleDeletePrivateUser}
          onView={handleViewPrivateUser}
        />
      )}
       {currentView === "form" && (
        <PrivateUserForm
          privateUserId={editingPrivateUser?.id} // Pass businessUserId prop
          onSubmit={editingPrivateUser ? handleUpdatePrivateUser : handleUpdatePrivateUser}
          onCancel={handleCancelEdit}
          onEdit={editingPrivateUser ? handleEditPrivateUser : () => {}}
          initialName={editingPrivateUser?.name}
          initialEmail={editingPrivateUser?.email}
          initialPhoneNumber={editingPrivateUser?.phoneNumber}
          initialAddress={editingPrivateUser?.address}
          initialAddress2={editingPrivateUser?.address2}
          initialCity={editingPrivateUser?.city}
          initialZipCode={editingPrivateUser?.zipCode}
          initialCountry={editingPrivateUser?.country}
          initialComments={editingPrivateUser?.comments}
          onSuccess={handleSuccess}
          isEditing={!!editingPrivateUser} // Pass isEditing prop
        />
      )}
      {currentView === "details" && selectedPrivateUser && (
        <PrivateUserDetail
          privateUser={selectedPrivateUser}
          onClose={handleCancelEdit}
          onEdit={handleEditPrivateUser}
        />
      )}
                
       
    </div>
  )
};

export default PrivateUsersManager;